import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import packageInfo from '../package.json';

if (environment.production) {
  Sentry.init({
    dsn: 'https://74c61c3a946c556cec8972e9e14e99d7@sentry.ftwmasters.com.br/19',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        networkDetailAllowUrls: ['localhost', /^https:\/\/api\.worldconquer\.online/],
      })
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    environment: environment.name,
    release: `long-angular@${packageInfo.version}`,
    enabled: environment.name !== 'local'
    // enabled: true
  });
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
